import { createContext } from 'react';

export default createContext({
	modals: [],
	pushModal: () => {},
	popModal: () => {},
	replaceModal: () => {}
});
